import React from 'react';
import Typography from '../../components/common/Typography';

export const isValidatePhoneEmail = (modalType, value) => {
  // 전화번호 검증
  if (modalType === 2 || modalType === 4) {
    console.log('value>>', value);
    if (!value) {
      return {
        isValid: false,
        //등록된 휴대전화가 없습니다
        messageKey: 'alertMessage.alertMessage01',
      };
    }

    if (value?.replaceAll('-', '').length < 10) {
      return {
        isValid: false,
        //등록된 휴대전화번호를 확인해주시기 바랍니다.
        messageKey: 'alertMessage.alertMessage02',
      };
    }
  }

  // 이메일 검증
  if (modalType === 3) {
    if (!value) {
      return {
        isValid: false,
        //이메일이 등록되어 있지 않습니다.
        messageKey: 'alertMessage.alertMessage03',
      };
    }

    if (!value.includes('@')) {
      return {
        isValid: false,
        //등록된 이메일을 확인해주시기 바랍니다.\r\n내정보에서 이메일 확인이 가능합니다.
        messageKey: 'alertMessage.alertMessage04',
      };
    }
  }

  return {
    isValid: true,
    messageKey: null,
  };
};

export const isValidateKakao = (checked, form) => {
  const { htmInsaPerNm, htmPerBirth, htmInsaPerHTel } = form;

  if (!checked) {
    return {
      isValid: false,
      //개인정보 제공동의서에 동의해주세요.
      messageKey: 'alertMessage.alertMessage06',
    };
  }

  if (!htmInsaPerNm) {
    return {
      isValid: false,
      //이름을 입력해주세요.
      messageKey: 'alertMessage.alertMessage07',
    };
  }

  if (!htmPerBirth) {
    return {
      isValid: false,
      //올바른 생년월일을 입력해주세요. 생년월일은 8글자입니다.
      messageKey: 'alertMessage.alertMessage08',
    };
  }

  if (!htmInsaPerHTel) {
    return {
      isValid: false,
      //올바른 전화번호를 입력해주세요.
      messageKey: 'alertMessage.alertMessage09',
    };
  }

  return {
    isValid: true,
    messageKey: null,
  };
};

export const kakaoErrorHandler = resultError => {
  if (resultError === 'E2001' || resultError === 'E2002') {
    //사용자 정보(이름, 휴대폰번호, 생년월일)을 확인 후 다시 시도하세요.
    return 'alertMessage.alertMessage10';
  }

  if (resultError === 'E2003') {
    //사용자의 카카오계정이 카카오 인증서비스를 이용할 수 없는 상태입니다. (휴먼,제재,보호상태)
    return 'alertMessage.alertMessage14';
  }

  if (resultError === 'E2005') {
    //다시 시도해주시기 바랍니다.
    return 'alertMessage.alertMessage11';
  }

  if (resultError === 'E2009') {
    //카카오 인증서비스를 이용할 수 없는 상태입니다.
    return 'alertMessage.alertMessage12';
  }

  if (resultError === 'E2010') {
    //사용자의 카카오계정에 본인인증 정보가 없습니다. 카카오톡에서 인증서를 발급받고 다시 시도하세요.
    return 'alertMessage.alertMessage13';
  }
};

export const kakaoCertErrorHandler = resultError => {
  if (resultError === 'REQUESTED') {
    //인증을 완료해주세요.
    return 'alertMessage.alertMessage15';
  }

  if (resultError === 'EXPIRED') {
    //유효시간이 경과하였습니다. 다시 인증해주세요.
    return 'alertMessage.alertMessage16';
  }
};

// 결과조회 페이지 배너 타이틀 가져오기
export const getResultQueryTitle = (resultData, t) => {
  if (resultData?.htmViewMagam == '2') {
    //아직 월급날에서 검수중입니다.
    return (
      <Typography className="displayFlex body2Medium" style={{ alignItems: 'flex-start' }}>
        {t('bannerSection.title1')}
        <Typography className="body2Bold" style={{ color: 'var(--Support-Pink)' }}>
          &nbsp;{t('bannerSection.title2')}
        </Typography>
        {t('bannerSection.title3')}
      </Typography>
    );
  } else if (resultData?.htmViewMagam == '1') {
    //월급날에서 검수중입니다.
    return (
      <Typography className="displayFlex body2Medium" style={{ alignItems: 'flex-start' }}>
        {resultData?.htmYAResultTxt} {t('bannerSection.title4')}
        <Typography className="body2Bold" style={{ color: 'var(--Support-Pink)' }}>
          &nbsp;{resultData?.htmYAResultMony}
        </Typography>
        {t('bannerSection.title5')}
      </Typography>
    );
  }
};

export const getResultQueryDescription = (resultData, t, resultAPI, isCertify) => {
  const createMsg = msgValue => {
    const formattedMsgValue = msgValue.split('\r\n').map((line, index) => (
      <Typography key={index} className="body2Medium">
        {line?.indexOf('필수제출') !== -1 && (
          <span className="body2Medium" style={{ color: 'var(--Support-Pink)' }}>
            [필수제출]
          </span>
        )}
        {line?.replaceAll('[필수제출]', '').replaceAll('필수제출', '').replaceAll('-', '')}
        <br />
      </Typography>
    ));

    return formattedMsgValue;
  };

  if (resultData?.htmViewMagam === '2') {
    // 월급날에서 검수중입니다.
    return (
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
        {isCertify && '서류 제출이 완료되었습니다.\r\n'}
        {resultData?.htmSubMent ? resultData?.htmSubMent : t('bannerSection.description')}
      </Typography>
    );
  } else if (resultData?.htmViewMagam === '1') {
    // 월급날 검토 결과입니다.
    const checkMsg = [];

    if (resultAPI) {
      const checkMsgKey = Object.keys(resultAPI);
      const checkMsgValue = Object.values(resultAPI);

      checkMsgKey.forEach((item, index) => {
        if (item.replaceAll('htm', '').length <= 4 && checkMsgValue[index] != null) {
          checkMsg.push(createMsg(checkMsgValue[index])); // createMsg 함수 사용
        }
      });
    }

    return (
      <Typography variant="body2Medium">
        {t('bannerSection.description2')}
        {checkMsg}
      </Typography>
    );
  }
};
